// extracted by mini-css-extract-plugin
module.exports = {"container":"DashboardPage_container__3oPoy"};